module.exports = __webpack_public_path__ + "static/media/Portrait-10047.ac44b658.jpg";